"use client";
import Theme, { GlobalColorMode } from "../Theme/index.js";
import { ToastProvider } from "../Toast/index.js";
import { SingletonEnvironmentContext, useSingletonRTL, } from "../../hooks/_private/useSingletonEnvironment.js";
import { SingletonHotkeysProvider } from "../../hooks/_private/useSingletonHotkeys.js";
import useSingletonKeyboardMode from "../../hooks/_private/useSingletonKeyboardMode.js";
import React from "react";
import { classNames } from "../../utilities/helpers.js";
import "./Reshaped.css";
import s from "./Reshaped.module.css";
const ReshapedInner = (props) => {
    const { children, defaultRTL, defaultViewport = "s", toastOptions } = props;
    const rtlState = useSingletonRTL(defaultRTL);
    useSingletonKeyboardMode();
    return (React.createElement(SingletonEnvironmentContext.Provider, { value: { rtl: rtlState, defaultViewport } },
        React.createElement(SingletonHotkeysProvider, null,
            React.createElement(ToastProvider, { options: toastOptions }, children))));
};
const Reshaped = (props) => {
    const { theme, defaultTheme = "reshaped", defaultColorMode, className } = props;
    const rootClassNames = classNames(s.root, className);
    return (React.createElement(GlobalColorMode, { defaultMode: defaultColorMode },
        React.createElement(Theme, { name: theme, defaultName: defaultTheme, className: rootClassNames },
            React.createElement(ReshapedInner, { ...props }, props.children))));
};
export default Reshaped;
